"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var moment = require("moment");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var scriptjs = require("scriptjs");
var Masonry = require("masonry-layout");
var imagesLoaded = require("imagesloaded");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.workId = this.options.workId;
        this.statsIsLoading = ko.observable(true);
        this.startDate = ko.observable(moment().startOf("day").add(-6, "days"));
        this.endDate = ko.observable(moment().endOf("day"));
        this.photoSwipe = null;
        this.showFullStats = ko.observable();
        this.statsFilterData = ko.computed(function () {
            var filterData = {
                startDate: _this.startDate().toISOString(),
                endDate: _this.endDate().toISOString(),
                itemId: _this.workId,
                groupBy: "work"
            };
            return filterData;
        });
        this.showFullStats(options.showFullStats);
        localStorageUtils_1.default.addToList(localStorageUtils_1.default.RecentlyViewedKey, options.workId);
        if (this.showFullStats()) {
            scriptjs([
                ajaxUtils_1.AjaxUtils.getFullUrl("dist/js/amcharts?v=140717")
            ], function () {
                ko.computed(function () {
                    _this.statsIsLoading(true);
                    _this.statsFilterData();
                    _this.loadDynamicChart();
                });
            });
        }
    }
    ViewModel.prototype.loadDynamicChart = function () {
        var _this = this;
        ajaxUtils_1.AjaxUtils.get("report/user-activity-data", this.statsFilterData())
            .done(function (result) {
            var daysInPerios = Math.floor((_this.endDate() - _this.startDate()) / (1000 * 60 * 60 * 24));
            var minPeriod = "DD";
            var categoryBalloonDateFormat = "MMMM DD, YYYY";
            if (daysInPerios > 40) {
                minPeriod = "MM";
                categoryBalloonDateFormat = "MMMM, YYYY";
            }
            _this.dynamicChart = AmCharts.makeChart("statsChartdiv", {
                language: "ru",
                type: "serial",
                theme: "light",
                valueAxes: [
                    {
                        id: "countAxis",
                        axisAlpha: 0,
                        position: "left",
                        integersOnly: true,
                        title: "Количество просмотров"
                    }, {
                        title: "Время чтения, часы",
                        id: "durationAxis",
                        axisAlpha: 0,
                        gridAlpha: 0,
                        position: "right"
                    }
                ],
                graphs: [
                    {
                        balloonText: "Просмотров: [[value]]",
                        fillAlphas: 0.7,
                        legendValueText: "[[value]]",
                        type: "column",
                        valueField: "totalViewCount",
                        valueAxis: "countAxis"
                    }, {
                        balloonText: "Время чтения: [[value]]",
                        type: "smoothedLine",
                        bullet: "round",
                        bulletBorderAlpha: 1,
                        useLineColorForBulletBorder: true,
                        bulletColor: "#FFFFFF",
                        hideBulletsCount: 30,
                        legendValueText: "[[value]] ч.",
                        fillAlphas: 0,
                        valueField: "spentTime",
                        valueAxis: "durationAxis"
                    }
                ],
                chartCursor: {
                    categoryBalloonDateFormat: categoryBalloonDateFormat,
                    cursorAlpha: 0.1,
                    cursorColor: "#000000",
                    fullWidth: true,
                    valueBalloonsEnabled: false,
                    zoomable: false
                },
                dataDateFormat: "DD.MM.YYYY",
                categoryField: "date",
                categoryAxis: {
                    parseDates: true,
                    dashLength: 1,
                    minorGridEnabled: true,
                    minPeriod: minPeriod
                },
                legend: {
                    equalWidths: false,
                    useGraphSettings: true,
                    align: "center"
                },
                dataProvider: result.data,
                pathToImages: app.rootUrl + "dist/vendor/amcharts/images/"
            });
            _this.statsIsLoading(false);
        });
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=androidWorkStats.js.map